module.exports = __webpack_public_path__ + "static/img/39.706d1ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/39.jpg
// module id = +olk
// module chunks = 1